// extracted by css-extract-rspack-plugin
export default {"Box_0":"VisibleAndOverflowContainer-module__Box_0__vDDvZ","space":"VisibleAndOverflowContainer-module__space__FN2Vl"};